import _ from 'lodash'
import { RootState } from '@/store/types';
import { MasterState, Nationality } from '@/store/master/types';
import axios from 'axios';
import { ActionTree } from 'vuex';

const actions: ActionTree<MasterState, RootState> = {
  fetchMasterPositions: (
    { commit },
  ) => axios.get('/master/positions').then((response) => {
    commit('fetchedMasterPositions', response.data);
  }),

  fetchMasterUniversities: (
    { commit },
  ) => axios.get('/master/universities').then((response) => {
    commit('fetchedMasterUniversities', response.data);
  }),

  fetchMasterCampuses: (
    { commit },
  ) => axios.get('/master/campuses').then((response) => {
    commit('fetchedMasterCampuses', response.data);
  }),

  fetchMasterSemesters: (
    { commit },
  ) => axios.get('/master/semesters').then((response) => {
    commit('fetchedMasterSemesters', response.data)
  }),

  fetchMasterNationalities: (
    { commit },
  ) => axios.get('/master/nationalities').then((response) => {
    commit('fetchedMasterNationalities', _.map(response.data, (n): Nationality => ({
      code: n.code,
      name: n.nameEnglish,
      nameJapanese: n.name,
    })))
  }),

  fetchMasterTimetables: (
    { commit },
  ) => axios.get('/master/timetables').then((response) => {
    commit('fetchedMasterTimetables', response.data);
  }),

  fetchMasterTransportationExpenses: (
    { commit },
  ) => axios.get('/master/transportationExpenses').then((response) => {
    commit('fetchedMasterTransportationExpenses', response.data);
  }),

  fetchMasterHolidays: (
    { commit },
  ) => axios.get('/master/holidays').then((response) => {
    commit('fetchedMasterHolidays', response.data);
  }),

  fetchMasterLevels: (
    { commit },
  ) => axios.get('/master/levels').then((response) => {
    commit('fetchedMasterLevels', response.data);
  }),

  fetchMasterSubjects: (
    { commit },
  ) => axios.get('/master/subjects').then((response) => {
    commit('fetchedMasterSubjects', response.data);
  }),

  fetchMasterVacationReasons: (
    { commit },
  ) => axios.get('/master/vacationReasons').then((response) => {
    commit('fetchedMasterVacationReasons', response.data);
  }),

  fetchMasterSpecialConsiderations: (
    { commit },
  ) => axios.get('/master/specialConsiderations').then((response) => {
    commit('fetchedMasterSpecialConsiderations', response.data)
  }),
};

export default actions;
